import React from 'react'

function RolesDataHead() {
    return <thead className="TableHead">
    <tr>
        <th className="bulkActions">STT</th>
        <th className="colItem">Object</th>
        <th className="colItem">Action</th>
        <th className="colItem">Type</th>
        <th className="colItem">Level</th>
        <th className="colItem">Status</th>
        <th className="bulkActions"/>
    </tr>
    </thead>
}

export default RolesDataHead
